import { memo, Fragment } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { dateSort } from '@hiredigital/lib/helpers/utils';

import Grid from '@components/Grid/Grid';

import IconBuilding from '@hiredigital/ui/Icon/tritone/building.inline.svg';
import IconMortarBoard from '@hiredigital/ui/Icon/tritone/mortarboard.inline.svg';
import IconDown from '@hiredigital/ui/Icon/icons/down.inline.svg';

import Styles from './Profile.module.scss';

const ResumeItem = dynamic(() => import('@components/Resume/Item'));

const Highlights = memo(
  ({
    highlightEmployment,
    highlightEducation,
    employmentCount,
    educationCount,
    toggleEmployment,
    toggleEducation,
  }) => {
    return (
      <Fragment>
        {(highlightEmployment.length > 0 || highlightEducation.length > 0) && (
          <div className={classNames(Styles.section)}>
            <Grid columns={2} className={Styles.grid}>
              {highlightEmployment.length > 0 && (
                <Grid.Item className={Styles.highlightColumn}>
                  <h3 className={Styles.title}>
                    <IconBuilding />
                    {`Employment Highlights`}
                  </h3>
                  {highlightEmployment
                    .sort(dateSort)
                    .filter((item) => item.highlight)
                    .slice(0, employmentCount)
                    .map((employment, index) => {
                      return (
                        <ResumeItem
                          key={index}
                          title={employment.jobTitle}
                          subtitle={employment.company}
                          startMonth={employment.startMonth}
                          startYear={employment.startYear}
                          endMonth={employment.endMonth}
                          endYear={employment.endYear}
                        />
                      );
                    })}

                  {highlightEmployment.length > 4 && (
                    <button className={Styles.showMore} onClick={toggleEmployment}>
                      {employmentCount ? (
                        <span>{`${
                          highlightEmployment.length - employmentCount
                        } More Entries`}</span>
                      ) : (
                        <Fragment>
                          <IconDown className={Styles.showLessIcon} /> {`Show Less`}
                        </Fragment>
                      )}
                    </button>
                  )}
                </Grid.Item>
              )}
              {highlightEducation.length > 0 && (
                <Grid.Item className={Styles.highlightColumn}>
                  <h3 className={Styles.title}>
                    <IconMortarBoard />
                    {`Education Highlights`}
                  </h3>
                  {highlightEducation
                    .sort(dateSort)
                    .filter((item) => item.highlight)
                    .slice(0, educationCount)
                    .map((education, index) => {
                      return (
                        <ResumeItem
                          key={index}
                          title={
                            education.qualification + (education.major && `, ` + education.major)
                          }
                          subtitle={education.institution}
                          startMonth={education.startMonth}
                          startYear={education.startYear}
                          endMonth={education.endMonth}
                          endYear={education.endYear}
                        />
                      );
                    })}
                  {highlightEducation.length > 4 && (
                    <button className={Styles.showMore} onClick={toggleEducation}>
                      {educationCount ? (
                        <span>{`${highlightEducation.length - educationCount} More Entries`}</span>
                      ) : (
                        <Fragment>
                          <IconDown className={Styles.showLessIcon} /> {`Show Less`}
                        </Fragment>
                      )}
                    </button>
                  )}
                </Grid.Item>
              )}
            </Grid>
          </div>
        )}
      </Fragment>
    );
  }
);

Highlights.propTypes = {
  className: PropTypes.string,
};

export default Highlights;
